export default __webpack_public_path__ + "static/media/opsgenie.8dc6c2a851d684d0b0f2b289e5d68f36.svg";